import React from 'react'
import HeaderPage from './layouts/Header/Index'

function NavTitle(props) {
  const { children, className = '', ...other } = props
  return (
    <>
      <div
        className={`${className} d-grid align-content-center w-100 `}
        style={{ height: '50px', position: 'sticky', minWidth: 0 }}
        {...other}
      >
        <HeaderPage childrenTitle={children} />
      </div>
    </>
  )
}

export default NavTitle
